import styled from '@emotion/styled'
import { default as MuiBaseFormHelperText, FormHelperTextProps } from '@mui/material/FormHelperText'

import { createComponentWrapperWithRef } from '../../theme'

export const FormHelperText = createComponentWrapperWithRef<FormHelperTextProps>(
  {
    mui: MuiBaseFormHelperText,
    nova: styled(MuiBaseFormHelperText)`
      padding: 2px 12px 0;
      margin-left: 0;
      &:empty {
        position: absolute;
      }
    `,
  },
  'FormHelperText',
)
